(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var mq = window.matchMedia('(max-width:749px)'), timer;
  function drawer(){ return document.getElementById('lox-drawer'); }
  function mega(){ return document.getElementById('lox-shopall'); }
  function open(){
    var d=drawer(); if(!d) return; clearTimeout(timer);
    d.hidden=false; document.body.classList.add('lox-menu-open');
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ d.classList.add('is-open'); }); });
    var x=d.querySelector('.lox-drawer__x'); if(x) setTimeout(function(){ x.focus({preventScroll:true}); },60);
  }
  function close(){
    var d=drawer(); if(!d||d.hidden) return;
    d.classList.remove('is-open'); document.body.classList.remove('lox-menu-open');
    timer=setTimeout(function(){ d.hidden=true; },380);
  }
  document.addEventListener('click',function(e){
    var d=drawer(), m=mega();
    if(e.target.closest('[data-lox-close]')){ e.preventDefault(); close(); return; }
    if(e.target.closest('[data-lox-menu]')){ e.preventDefault(); e.stopImmediatePropagation(); (d&&!d.hidden)?close():open(); return; }
    if(m && mq.matches && e.target.closest('#lox-shopall > summary')){ e.preventDefault(); open(); return; }
    if(m && m.open && !m.contains(e.target)){ m.open=false; }
  }, true);
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape') return;
    var d=drawer(); if(d && !d.hidden){ close(); return; }
    var m=mega(); if(m && m.open){ m.open=false; m.querySelector('summary').focus(); }
  });
  window.addEventListener('pageshow',function(){ var d=drawer(); if(d){ d.classList.remove('is-open'); d.hidden=true; document.body.classList.remove('lox-menu-open'); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-product-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(sec){
    if(!sec || sec.dataset.ready) return; sec.dataset.ready='1';
    if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r=sec.getBoundingClientRect(); if(r.top < window.innerHeight*0.9) { sec.classList.add('go'); return; }
    sec.classList.add('is-pre');
    var io=new IntersectionObserver(function(es){ if(es[0].isIntersecting){ sec.classList.remove('is-pre'); sec.classList.add('go'); io.disconnect(); } },{threshold:.15});
    io.observe(sec);
  }
  function boot(){ document.querySelectorAll('[data-lox-pg]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function tag(sec){ var n=0; sec.querySelectorAll('.jdgm-rev:not(.lox-in)').forEach(function(r){ r.style.setProperty('--n',n++ % 6); r.classList.add('lox-in'); }); }
  function init(sec){
    if(!sec || sec.dataset.ready) return; sec.dataset.ready='1';
    var go=function(){ sec.classList.add('go'); tag(sec); };
    if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){ if(es[0].isIntersecting){ go(); io.disconnect(); } },{threshold:.12}); io.observe(sec); } else go();
    if('MutationObserver' in window){ new MutationObserver(function(){ if(sec.classList.contains('go')) tag(sec); }).observe(sec,{childList:true,subtree:true}); }
  }
  function boot(){ document.querySelectorAll('[data-lox-prev]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-product"]) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.ready) return; root.dataset.ready='1';
    var q=function(s){ return root.querySelector(s); };
    var T={add:root.dataset.tAdd,sold:root.dataset.tSold,unavail:root.dataset.tUnavail,stock:root.dataset.tStock,added:root.dataset.tAdded||'Added to cart'};

    /* gallery */
    var gal=q('[data-lox-gal]'), track=gal&&gal.querySelector('[data-track]'), counter=gal&&gal.querySelector('[data-count]');
    var thumbs=gal?[].slice.call(gal.querySelectorAll('[data-go]')):[];
    function go(i){ if(!track) return; var s=track.children[i]; if(s) track.scrollTo({left:s.offsetLeft,behavior:'smooth'}); }
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ go(+t.dataset.go); }); });
    if(track){
      var raf;
      track.addEventListener('scroll',function(){ cancelAnimationFrame(raf); raf=requestAnimationFrame(function(){
        var i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));
        thumbs.forEach(function(t,k){ if(k===i){ t.setAttribute('aria-current','true'); if(t.scrollIntoView && t.parentNode.scrollWidth>t.parentNode.clientWidth){ t.parentNode.scrollTo({left:t.offsetLeft-t.parentNode.clientWidth/2+t.clientWidth/2,behavior:'smooth'}); } } else t.removeAttribute('aria-current'); });
        if(counter) counter.textContent=(i+1)+' / '+track.children.length;
      }); },{passive:true});
      track.addEventListener('keydown',function(e){ var i=Math.round(track.scrollLeft/track.clientWidth); if(e.key==='ArrowRight'){ e.preventDefault(); go(i+1); } if(e.key==='ArrowLeft'){ e.preventDefault(); go(i-1); } });
    }

    /* variants */
    var vs=[]; try{ vs=JSON.parse(q('[data-lox-variants]').textContent); }catch(e){}
    var form=q('[data-lox-form]'), idIn=form&&form.querySelector('[data-vid]'), add=q('[data-add]'), label=q('[data-add-label]');
    var fields=[].slice.call(root.querySelectorAll('.lox-opt'));
    function pick(){ var sel=fields.map(function(f){ var c=f.querySelector('input:checked'); return c?c.value:null; });
      for(var i=0;i<vs.length;i++){ var ok=true; for(var k=0;k<sel.length;k++){ if(vs[i].options[k]!==sel[k]){ ok=false; break; } } if(ok) return vs[i]; } return null; }
    function apply(v){
      fields.forEach(function(f){ var c=f.querySelector('input:checked'), b=f.querySelector('[data-optval]'); if(c&&b) b.textContent=c.value; });
      var stock=q('[data-stock]');
      if(!v){ add.disabled=true; label.textContent=T.unavail; return; }
      idIn.value=v.id;
      q('[data-now]').textContent=v.price;
      var cmp=q('[data-compare]'), sb=q('[data-salebadge]'), sv=q('[data-save]');
      cmp.hidden=sb.hidden=!v.compare; if(sv) sv.hidden=!v.compare;
      if(v.compare){ cmp.textContent=v.compare; if(sv) sv.textContent='Save '+v.save+'%'; }
      add.disabled=!v.available; label.textContent=v.available?T.add:T.sold;
      stock.textContent=!v.available?T.sold:(v.low>0?(stock.dataset.lowTpl||'Only [n] left in stock').replace('[n]',v.low):T.stock); stock.classList.toggle('is-out',!v.available); stock.classList.toggle('is-low',v.available&&v.low>0);
      var sp=document.querySelector('[data-satc-price]'); if(sp) sp.textContent=v.price;
      if(v.media && track){ for(var j=0;j<track.children.length;j++){ if(track.children[j].dataset.mediaId==String(v.media)){ go(j); break; } } }
      try{ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(history.state,'',u.toString()); }catch(e){}
    }
    fields.forEach(function(f){ f.addEventListener('change',function(){ apply(pick()); }); });

    /* quantity */
    root.querySelectorAll('[data-q]').forEach(function(b){ b.addEventListener('click',function(){ var i=form.querySelector('[name="quantity"]'); i.value=Math.max(1,(parseInt(i.value,10)||1)+(+b.dataset.q)); }); });

    /* add to cart (ajax, falls back to normal submit) */
    var toast=q('[data-toast]'), tmsg=q('[data-toast-msg]'), tt;
    function show(ok,msg){ if(!toast) return; tmsg.textContent=msg; toast.classList.toggle('is-err',!ok); toast.hidden=false; toast.style.animation='none'; toast.offsetHeight; toast.style.animation=''; clearTimeout(tt); tt=setTimeout(function(){ toast.hidden=true; },ok?4200:5200); }
    function bump(n){
      document.querySelectorAll('.lox-cart-count').forEach(function(el){ el.textContent=n; });
      document.querySelectorAll('.lox-tabbar a[href$="/cart"]').forEach(function(a){ var c=a.querySelector('.cnt'); if(!c){ c=document.createElement('span'); c.className='cnt'; a.insertBefore(c,a.querySelector('svg').nextSibling); } c.textContent=n; });
    }
    if(form && window.fetch && window.FormData){
      form.addEventListener('submit',function(e){
        e.preventDefault(); if(add.disabled) return;
        add.classList.add('is-busy');
        var base=(window.routes&&window.routes.cart_add_url)||'/cart/add';
        fetch(base+'.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
          .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
          .then(function(){ return fetch(((window.routes&&window.routes.cart_url)||'/cart')+'.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }); })
          .then(function(cart){ bump(cart.item_count); add.classList.remove('is-busy'); add.classList.add('is-done'); label.textContent='✓ '+T.added; show(true,T.added);
            setTimeout(function(){ add.classList.remove('is-done'); label.textContent=add.disabled?T.sold:T.add; },2200); })
          .catch(function(err){ add.classList.remove('is-busy'); show(false,(err&&(err.description||err.message))||'Could not add to cart. Please try again.'); });
      });
    }
  }
  function boot(){ document.querySelectorAll('[data-lox-pdp]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
